import type { Editor } from '@tiptap/core'

type HeadingLevel = 1 | 2 | 3

export function toggleHeadingWithSelection(editor: Editor | null | undefined, level: HeadingLevel): boolean {
  if (!editor || editor.isDestroyed) return false

  const { from, to, empty } = editor.state.selection

  if (!empty) {
    const selectedText = editor.state.doc.textBetween(from, to)
    const startPos = editor.state.doc.resolve(from)
    const endPos = editor.state.doc.resolve(to)

    if (startPos.parent === endPos.parent) {
      editor.chain()
        .focus()
        .deleteRange({ from, to })
        .insertContent([
          { type: 'paragraph' },
          {
            type: 'heading',
            attrs: { level },
            content: [{ type: 'text', text: selectedText }]
          },
          { type: 'paragraph' }
        ])
        .run()
      return true
    }

    editor.chain()
      .focus()
      .setTextSelection({ from, to })
      // @ts-expect-error - toggleHeading exists but types may not be complete
      .toggleHeading({ level })
      .run()
    return true
  }

  // @ts-expect-error - toggleHeading exists but types may not be complete
  editor.chain().focus().toggleHeading({ level }).run()
  return true
}
